<template>
    <van-nav-bar :title="title" style="blue">
        <template #left>
            <img v-if="showLeft" class="leftarrow" @click="goback" src="../../assets/leftarrow.png" alt="">
        </template>
        <template #right>
            <img v-if="showRight" class="blackdot" src="../../assets/blackdot.png" alt="">
        </template>
    </van-nav-bar>
</template>

<script>
export default {
    name: 'navbar',
    props: {
        showLeft: { //展示左边小图标
            type: Boolean,
            default: true
        },
        showRight: { //展示右边小图标
            type: Boolean,
            default: true
        },
        title: { //展示title
            type: String,
            default: ''
        }
    },
    methods: {
        goback() {
            console.log('hrere')
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="scss" scoped>
    .leftarrow {
        width: .24rem;
        height: .4rem;
    }
    .blackdot {
        width: .46rem;
        height: .1rem;
    }
</style>